import {
    ButtonBase,
    Checkbox,
    DialogContent,
    FormControlLabel,
    FormGroup,
} from "@mui/material";
import _, { set, toInteger } from "lodash";
import React, { useContext, useEffect, useMemo, useState } from "react";
import NumPad from "react-numpad";
import { AppContext } from "../../../../AppContext";
import backIcon from "../../../../images/back-icon.svg";
import { ItemDialog, ItemSmallButton, useStyles } from "./style";
import { PosContext } from "../../../../shared/PosContext";

function AddItemWidget({
    item,
    onClose,
    open,
    onAddItem,
    onUpdateItem,
    pushItemWorker,
    editedOrderItem,
}) {
    const classes = useStyles();
    const [selectedAddons, setSelectedAddons] = useState([]);

    const { addonsItems } = useContext(PosContext);

    const addonItems = useMemo(() => {
        if (addonsItems) {
            return addonsItems;
        }
        return [];
    }, [addonsItems]);

    const [qty, setQty] = useState(1);
    const [notes, setNotes] = useState("");

    const { menuAddons } = useContext(AppContext);

    const [itemRate, setItemRate] = useState(0);
    const [total, setTotal] = useState(0);
    const [addonsTotal, setAddonsTotal] = useState(0);

    const reset = () => {
        setSelectedAddons([]);
        setQty(1);
        setNotes("");
        setItemRate(0);
        setTotal(0);
        setAddonsTotal(0);
    };

    useEffect(() => {
        if (editedOrderItem) {
            setItemRate(editedOrderItem.item.standard_rate);
            const tmpQty = editedOrderItem.qty;
            const addons = editedOrderItem.addons;
            setNotes(editedOrderItem.notes);
            setQty(tmpQty);
            setSelectedAddons(editedOrderItem.addons.map((i) => i.item_code));
        } else {
            if (item) {
                const { standard_rate, notes, addons } = item;
                setItemRate(standard_rate);
                setNotes(notes);
                setQty(1);
                setTotal(standard_rate * 1);
            } else {
                setItemRate(0);
                setQty(1);
                setNotes("");
            }
        }
    }, [item, open, editedOrderItem]);

    useEffect(() => {
        const calculateAddonsTotal = () => {
            let addonsTotal = 0;
            setTotal(itemRate * qty);
            if (
                !menuAddons ||
                menuAddons.length === 0 ||
                !selectedAddons ||
                selectedAddons.length === 0
            ) {
                setAddonsTotal(0);
                return;
            }

            selectedAddons.forEach((oneItem) => {
                const foundItem = _.find(menuAddons, {
                    item_code: oneItem,
                });
                if (foundItem) {
                    addonsTotal += foundItem.standard_rate * qty;
                }
            });

            setTotal(itemRate * qty + addonsTotal);
            setAddonsTotal(addonsTotal);
        };

        const timer = setTimeout(calculateAddonsTotal, 100);

        return () => {
            clearTimeout(timer);
        };
    }, [qty, selectedAddons]);

    const handleNotesChange = (event) => {
        setNotes(event.target.value);
    };

    const addQty = (addedQty) => {
        if (qty + addedQty > 0) setQty(qty + addedQty);
    };

    const handleClose = () => {
        reset();
        if (onClose) {
            onClose();
        }
    };

    const handleClick = () => {
        if (editedOrderItem) {
            const updatedEntry = {
                ...editedOrderItem,
                qty,
                addons: selectedAddons,
                notes,
            };

            if (updatedEntry.item) {
                updatedEntry.item.qty = qty;
                updatedEntry.item.addons = selectedAddons;
                updatedEntry.item.notes = notes;
            }
            onUpdateItem(updatedEntry, false);
        } else {
            onAddItem(
                { ...item, ["qty"]: qty, ["notes"]: notes },
                qty,
                selectedAddons,
                notes,
                true
            );
        }
        handleClose();
        // setTimeout(reset, 1000);
    };

    const handleCheckboxChange = (event) => {
        const { checked, value } = event.target;

        setSelectedAddons((prev) => {
            if (checked) {
                return _.xor(prev, [value]);
            } else {
                return _.without(selectedAddons, value);
            }
        });
    };

    return item ? (
        <>
            <ItemDialog
                className={classes.DialogWrap}
                onClose={() => {
                    handleClose();
                }}
                open={open}
            >
                <DialogContent>
                    <div>
                        <button className="BackBtn">
                            <img
                                src={backIcon}
                                onClick={() => {
                                    handleClose();
                                }}
                            />
                        </button>
                    </div>

                    <div className={classes.Header}>
                        <div className={classes.ItemDesc}>
                            <img
                                className={classes.ItemDescImage}
                                src={item.cover}
                            />
                            <div>
                                <div className={classes.ItemDescName}>
                                    {item.item_code}
                                </div>
                                <div className={classes.ItemDescPrice}>
                                    {item.standard_rate}
                                </div>
                            </div>
                        </div>

                        <div className={classes.ItemQty}>
                            <ItemSmallButton
                                onClick={() => addQty(-1)}
                                className={classes.ItemQtyMinus}
                            >
                                -
                            </ItemSmallButton>
                            <NumPad.Number
                                onChange={(value) => {
                                    setQty(value > 0 ? toInteger(value) : 1);
                                }}
                                isDecimal={false}
                                position={"startBottomRight"}
                                min={1}
                                value={0}
                            >
                                <div className={classes.ItemQtyText}>{qty}</div>
                            </NumPad.Number>
                            <ItemSmallButton
                                onClick={() => addQty(1)}
                                className={classes.ItemQtyPlus}
                            >
                                +
                            </ItemSmallButton>
                        </div>
                    </div>

                    <div className={classes.Addons}>
                        <div>Extra Add-ons</div>
                        <FormGroup className={classes.AddonsList}>
                            {item.allowed_addons
                                ? item.allowed_addons.map((addonsItem) => {
                                      const addon =
                                          addonItems.find(
                                              (i) => i.item_code === addonsItem
                                          ) || {};
                                      return (
                                          <div
                                              className={classes.AddonsRaw}
                                              key={addonsItem}
                                          >
                                              <FormControlLabel
                                                  control={
                                                      <Checkbox
                                                          onChange={
                                                              handleCheckboxChange
                                                          }
                                                          checked={
                                                              selectedAddons.find(
                                                                  (i) =>
                                                                      i ===
                                                                      addonsItem
                                                              ) != null
                                                          }
                                                          value={addonsItem}
                                                      />
                                                  }
                                                  label={`${addonsItem} `}
                                              />
                                              <span>{addon.standard_rate}</span>
                                          </div>
                                      );
                                  })
                                : ""}
                        </FormGroup>
                    </div>

                    <div>
                        <div className={classes.Notes}>Notes</div>
                        <textarea
                            value={notes}
                            onChange={handleNotesChange}
                            width="300"
                            height="80"
                            placeholder="Add notes here"
                            className={classes.NotesArea}
                        ></textarea>
                    </div>

                    <div className={classes.Footer}>
                        <div>
                            <div className={classes.TotalText}>Total</div>
                            <div>
                                <div className={classes.TotalPrice}>
                                    {total}
                                </div>
                                <div className={classes.AddonsPrice}>
                                    (Add-ons {addonsTotal})
                                </div>
                            </div>
                        </div>
                        <ButtonBase
                            onClick={handleClick}
                            className={classes.DialogAction}
                        >
                            {pushItemWorker.isLoading ? "Saving ..." : "Save"}
                        </ButtonBase>
                    </div>
                </DialogContent>
            </ItemDialog>
        </>
    ) : (
        ""
    );
}

export default AddItemWidget;
